import { CanUpdateTripOutput } from '@allocab/allocab-passenger-shared-types';

import { ToastManager } from '../../../services/toast/utils';
import { t } from '../../../services/translation/translation';
import { GradientButton } from '../../button/GradientButton';
import { ModalTitle } from '../../Modal';

type Props = {
  data?: CanUpdateTripOutput;
  onValidate: (_value: 'changeDepartureAt' | 'changeStartAddress' | 'changeEndAddress') => void;
  tripFlash: boolean;
};

export const UpdateTripChoice = ({ data, onValidate, tripFlash }: Props) => {
  const onValidateUpdateStartAddress = () => {
    if (!data?.canUpdateStartAddress) {
      ToastManager.show({ severity: 'warning', message: t('update-trip.modal.warning.cant-update-start-addresse') });
    } else {
      onValidate('changeStartAddress');
    }
  };

  const onValidateUpdateEndAddress = () => {
    if (!data?.canUpdateEndAddress) {
      ToastManager.show({ severity: 'warning', message: t('update-trip.modal.warning.cant-update-end-addresse') });
    } else {
      onValidate('changeEndAddress');
    }
  };

  const onValidateUpdateDepartureAt = () => {
    if (!data?.canUpdateDepartureAt) {
      ToastManager.show({ severity: 'warning', message: t('update-trip.modal.warning.cant-update-departure-at') });
    } else {
      onValidate('changeDepartureAt');
    }
  };
  return (
    <div>
      <ModalTitle title={t('update-trip.modal-title')} />
      {data?.canUpdateDepartureAt && data?.canUpdateEndAddress && data?.canUpdateStartAddress ? (
        <div className="text-center">{t('update-trip.modal-subtitle')}</div>
      ) : (
        <div className="text-center mt-3">{t('update-trip.modal-subtitle-cant')}</div>
      )}
      <div className="space-y-3 mt-5">
        {data?.canUpdateStartAddress ? (
          <div className="space-y-3 text-center">
            <div>{t('update-trip.modal.start-address-title')}</div>
            <GradientButton onClick={() => onValidateUpdateStartAddress()} className="w-full space-y-3 mt-2">
              {t('update-trip.modal.start-address-button')}
            </GradientButton>
          </div>
        ) : null}
        {data?.canUpdateEndAddress ? (
          <div className="space-y-3 text-center">
            <div>{t('update-trip.modal.end-address-title')}</div>
            <GradientButton onClick={() => onValidateUpdateEndAddress()} className="w-full space-y-3 mt-2">
              {t('update-trip.modal.end-address-button')}
            </GradientButton>
          </div>
        ) : null}
        {tripFlash === false && data?.canUpdateDepartureAt ? (
          <div className="space-y-3 text-center">
            <div>{t('update-trip.modal.departure-at-title')}</div>
            <GradientButton onClick={() => onValidateUpdateDepartureAt()} className="w-full space-y-3 mt-2">
              {t('update-trip.modal.departure-at-button')}
            </GradientButton>
          </div>
        ) : null}
      </div>
    </div>
  );
};
